import { render } from "./CourierManage.vue?vue&type=template&id=453ed748"
import script from "./CourierManage.vue?vue&type=script&lang=js"
export * from "./CourierManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__